var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircularBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#C9CEFA",
    stroke: "#ABB2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2039_4165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0791 13.995C22.7524 13.6683 22.2257 13.6683 21.8991 13.995L16.3591 19.535C16.0991 19.795 16.0991 20.215 16.3591 20.475L21.8991 26.015C22.2257 26.3417 22.7524 26.3417 23.0791 26.015C23.4057 25.6883 23.4057 25.1617 23.0791 24.835L18.2524 20.0017L23.0857 15.1683C23.4057 14.8483 23.4057 14.315 23.0791 13.995Z",
    fill: "#282860"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2039_4165"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularBackBtn);
export default __webpack_public_path__ + "static/media/circularBackBtn.9acdc6f97bfda90351321c4b425034d4.svg";
export { ForwardRef as ReactComponent };